module.exports = __webpack_public_path__ + "static/media/cc775110-ccbb-457c-b26a-525d90e3fe0f.55cf3843.jpg";